import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * PayPal atšaukimo puslapis: vartotojas atšaukė mokėjimą PayPal.
 * Nukreipiame į užsakymo puslapį (jei yra order_id), kad galėtų mokėti iš naujo arba matyti užsakymą.
 * Be order_id – į užsakymų sąrašą.
 */
function PaymentPayPalCancel() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get('order_id');

  useEffect(() => {
    if (orderId) {
      navigate(`/orders/${orderId}`, { replace: true });
    } else {
      navigate('/orders', { replace: true });
    }
  }, [orderId, navigate]);

  return null;
}

export default PaymentPayPalCancel;
